import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import BackPageButton from "../../components/common-components/BackPageButton";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import {
  DocumentUploadIcon,
  PreviewIcon,
} from "../../assets/Icon/dashboredIcon";
import { useParams } from "react-router-dom";
import PreviewModal from "../../components/itin/PreviewModal";
import { useDispatch } from "react-redux";
import { GetOperatingAgreementDetails } from "../../stores/orders";
import {
  NumberOrderIcon,
  OrderCalender,
} from "../../assets/Icon/OrderDetailIcon";
import { getUrl } from "../../stores/incorporation";
import { setToast } from "../../stores/toast/toastslice";
import { toPreviewUrl, toStorageKey } from "../../utils/fileUrl";

const OperatingAgreementDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const [data, setData] = useState<any>(null);
  const [img, setImg] = useState("");

  const getOperatingAgreementData = async () => {
    if (id) {
      const response = await dispatch<any>(
        GetOperatingAgreementDetails({ order_id: id }),
      );
      setData(response?.payload?.data);
    }
  };

  console.log(data, "-----------------------");

  useEffect(() => {
    getOperatingAgreementData();
  }, [id]);

  const formatToTimeZone = (
    dateInput: string | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    },
  ): string => {
    if (!dateInput) return "Invalid Date";

    const date = new Date(
      typeof dateInput === "string" && !dateInput.endsWith("Z")
        ? dateInput + "Z"
        : dateInput,
    );

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone,
      ...options,
    }).format(date);
  };

  // `documents[].document_file_url` comes back as an absolute S3 url while
  // `passport` / `generated_agreement_file` come back as keys. The download
  // endpoint presigns a key, so normalise before asking for it.
  const handleDownload = async (url?: string | null) => {
    const key = toStorageKey(url);
    if (!key) {
      dispatch<any>(
        setToast({
          message: "This file is not available yet.",
          type: "error",
          title: "Not available",
        }),
      );
      return;
    }

    const response = await dispatch<any>(getUrl({ url: key }));
    const fileUrl = response?.payload?.data;
    if (!fileUrl) {
      dispatch<any>(
        setToast({
          message: response?.payload?.message || "Unable to download this file.",
          type: "error",
          title: "Error",
        }),
      );
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreview = (url?: string | null) => {
    const previewUrl = toPreviewUrl(url);
    if (!previewUrl) {
      dispatch<any>(
        setToast({
          message: "This file is not available yet.",
          type: "error",
          title: "Not available",
        }),
      );
      return;
    }
    setImg(previewUrl);
    setOpenPreview(true);
  };

  const handleClose = () => {
    setOpenPreview(false);
  };

  console.log(img, "jgjdfgndfjgnd");

  return (
    <StyledBox>
      <BackPageButton />
      <div
        style={{
          fontWeight: "500",
          fontSize: "24px",
        }}
      >
        Operating Agreement
      </div>

      <Box
        sx={{
          borderBottom: "2px solid #EAF1FA",
          mb: 2,
          position: "relative",
          paddingY: "30px",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "#2977CC",
            fontWeight: 600,
            fontSize: "20px",
            borderBottom: "2px solid #2977CC",
            display: "inline-block",
            pb: 0.5,
            position: "absolute",
            bottom: "-2px",
          }}
        >
          Details
        </Typography>
      </Box>
      {/* LEFT SIDE */}
      <Grid container spacing={2}>
        <StyledGridBox
          size={{ xs: 12, md: 8 }}
          sx={{
            border: "2px solid #EAF1FA",
            borderRadius: "12px",
            padding: "35px",
            height: "fit-content",
          }}
        >
          <p
            style={{
              fontSize: "19px",
              fontWeight: "600",
              marginBottom: 10,
              marginTop: 10,
            }}
          >
            Form Fields
          </p>
          {data?.documents?.length ? (
            <div
              style={{
                border: "1px solid #EAF1FA",
                borderRadius: "8px",
                padding: "20px",
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "500px auto",
                  alignItems: "center",
                  borderBottom: "1px solid #EAF1FA",
                  padding: "20px 0",
                  columnGap: "20px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#6c6f71",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Application options
                </p>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#01060b",
                  }}
                ></p>
              </div>
              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #EAF1FA",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#6c6f71",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Name
                </p>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#01060b",
                  }}
                >
                  {data?.data?.user?.first_name} {data?.data?.user?.last_name}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #EAF1FA",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#6c6f71",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Email
                </p>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#01060b",
                  }}
                >
                  {data?.data?.user?.email}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #EAF1FA",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#6c6f71",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Company type
                </p>
                <p
                  style={{
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#01060b",
                  }}
                >
                  {data?.data?.company_type}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #EAF1FA",
                  alignItems: "center",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <div>
                  <p
                    style={{
                      margin: 0,
                      color: "#6c6f71",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    Passport
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#6c6f71",
                      fontWeight: "500",
                      fontSize: "14px",
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() => handlePreview(data?.data?.passport)}
                  >
                    <PreviewIcon />
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: "500",
                      fontSize: "14px",
                      marginTop: 3,
                      color: "#01060b",
                    }}
                    onClick={() => {
                      handleDownload(data?.data?.passport);
                    }}
                  >
                    <DocumentUploadIcon />
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #EAF1FA",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: "#6c6f71",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Company document
                </p>
                <div
                  style={{
                    display: "grid",
                  }}
                >
                  {data?.documents?.map((item: any) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: "#6c6f71",
                            fontWeight: "500",
                            fontSize: "14px",
                          }}
                          onClick={() => handlePreview(item?.document_file_url)}
                        >
                          <PreviewIcon />
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "500",
                            fontSize: "14px",
                            marginTop: 3,
                            color: "#01060b",
                          }}
                          onClick={() => {
                            handleDownload(item?.document_file_url);
                          }}
                        >
                          <DocumentUploadIcon />
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  // gridTemplateColumns: "500px auto",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px 0",
                  columnGap: "20px",
                  paddingRight: "200px",
                }}
              >
                <div>
                  <p
                    style={{
                      margin: 0,
                      color: "#6c6f71",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    Operating Agreement file
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#6c6f71",
                      fontWeight: "500",
                      fontSize: "14px",
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() =>
                      handlePreview(data?.data?.generated_agreement_file)
                    }
                  >
                    <PreviewIcon />
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: "500",
                      fontSize: "14px",
                      marginTop: 3,
                      color: "#01060b",
                    }}
                    onClick={() => {
                      handleDownload(data?.data?.generated_agreement_file);
                    }}
                  >
                    <DocumentUploadIcon />
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #EAF1FA",
                borderRadius: "8px",
                padding: "0px",
                overflowX: "auto",
                whiteSpace: "nowrap",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <NoOrdersFound />
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "18px",
                  marginTop: "-20px",
                  marginBottom: 40,
                }}
              >
                No data found!
              </div>
            </div>
          )}
        </StyledGridBox>

        {/** RIGHT SIDE  */}
        <Grid size={{ xs: 12, md: 4 }}>
          {false ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <ListLoadingNew />
            </Box>
          ) : true ? (
            <div
              style={{
                border: "1px solid #EAF1FA",
                borderRadius: "8px",
                padding: "20px",
                overflowX: "auto", // 🔥 enables horizontal scrolling
                whiteSpace: "nowrap", // prevents wrapping
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  color: "#01060B",
                  paddingTop: "20px",
                  paddingBottom: "10px",
                  fontWeight: "600",
                  minWidth: "200px", // optional: ensures consistent width
                }}
              >
                Details
              </div>

              <div style={{ minWidth: "200px" /* keeps grid inside */ }}>
                {[
                  { label: "Application options", value: "" },
                  { label: "Number", value: data?.data?.id },
                  {
                    label: "Created",
                    value: formatToTimeZone(data?.data?.created_at),
                  },
                  { label: "Service", value: "Operating Agreement" },
                  { label: "Related", value: id },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px auto",
                      alignItems: "center",
                      borderBottom: "1px solid #EAF1FA",
                      padding: "20px 0",
                      columnGap: "20px",
                      minWidth: "400px", // 🔥 keeps each row wide enough for scroll
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        color: "#6c6f71",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {item.label}
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#01060b",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      {item?.label === "Created" && <OrderCalender />}{" "}
                      {item?.label === "Number" && <NumberOrderIcon />}{" "}
                      {item.value}
                    </p>
                  </div>
                ))}

                {/* Started/Completed row */}
                {/* <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "200px auto",
                    alignItems: "center",
                    borderBottom: "1px solid #EAF1FA",
                    padding: "20px 0",
                    columnGap: "20px",
                    minWidth: "400px",
                  }}
                >
                  <div>
                    <p
                      style={{
                        margin: 0,
                        color: "#6c6f71",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      Started
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: "14px",
                        marginTop: 3,
                        color: "#01060b",
                      }}
                    >
                      03/06/2020
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        margin: 0,
                        color: "#6c6f71",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      Completed
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: "14px",
                        marginTop: 3,
                        color: "#01060b",
                      }}
                    >
                      12/02/2023
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          ) : false ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <NoOrdersFound title="No Data Found" showImage={false} />
            </Box>
          ) : null}

          {/** CLIENT BOX */}
          <div
            style={{
              border: "1px solid #EAF1FA",
              borderRadius: "8px",
              padding: "20px",
              overflowX: "auto",
              whiteSpace: "nowrap",
              marginTop: 20,
            }}
          >
            <div
              style={{
                fontSize: "20px",
                color: "#01060B",
                paddingTop: "20px",
                paddingBottom: "10px",
                fontWeight: "600",
                minWidth: "200px",
              }}
            >
              Client
            </div>

            <div style={{ minWidth: "200px" /* keeps grid inside */ }}>
              {[{ label: "Applications options", value: "" }].map(
                (item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px auto",
                      alignItems: "center",
                      borderBottom: "1px solid #EAF1FA",
                      padding: "20px 0",
                      columnGap: "20px",
                      minWidth: "400px", // 🔥 keeps each row wide enough for scroll
                    }}
                  >
                    <p
                      style={{
                        margin: 0,
                        color: "#6c6f71",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {item.label}
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#01060b",
                      }}
                    >
                      {item.value}
                    </p>
                  </div>
                ),
              )}

              {/* Started/Completed row */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "200px auto",
                  alignItems: "center",
                  padding: "20px 0",
                  columnGap: "20px",
                  minWidth: "400px",
                }}
              >
                <div>
                  <p
                    style={{
                      margin: 0,
                      color: "#6c6f71",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Users
                  </p>
                </div>
                <div>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: "500",
                      fontSize: "14px",
                      marginTop: 3,
                      color: "#01060b",
                    }}
                  >
                    {data?.user_name}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {false ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <ListLoadingNew />
            </Box>
          ) : true ? (
            ""
          ) : true ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                marginTop: "8px",
                width: "100%",
                border: "1px solid #EAF1FA",
                borderRadius: "12px",
                backgroundColor: "#FFF",
              }}
            >
              <NoOrdersFound title="No Data Found" showImage={false} />
            </Box>
          ) : null}
        </Grid>
      </Grid>
      <PreviewModal open={openPreview} handleClose={handleClose} img={img} />
    </StyledBox>
  );
};

export default OperatingAgreementDetails;

interface OrderTitleProps {
  isClassName?: boolean;
}
export const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  padding: "16px",
});
export const StyledGridBox = styled(Grid)(({ theme }) => ({
  border: "2px solid #EAF1FA",
  borderRadius: "12px",
  // padding: "10px",
}));
export const OrderTitle = styled(Typography)<OrderTitleProps>(
  ({ isClassName }) => ({
    fontSize: "19px !important",
    color: "#01060B",
    paddingTop: isClassName ? "10px" : "20px",
    paddingBottom: "10px",
  }),
);
export const StyledGridBoxChild = styled(Grid)(({ theme }) => ({
  border: "1px solid #EAF1FA",
  borderRadius: "8px",
  padding: "20px",
}));
export const FormTItle = styled(Typography)({
  fontSize: "14px !important",
  color: "#6C6F71",
  fontWeight: 500,
});
export const FormTItleValue = styled(Typography)({
  width: "50%",
  fontSize: "14px !important",
  color: "#01060B",
  fontWeight: 500,
  display: "flex",
  // alignItems: "center",
});
